<template>
  <div class='plus-view'>
    <template v-if='loading'>
      <loader width='48px' height='48px' stroke='#4C4C4C' />
    </template>
    <template v-else>

      <component
        :is='tableType'
        :tableOptions='tableOptions'
        @changePage='changePage'
      />

    </template>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex';
import TableElement from '@/components/common/TableElement';

import * as tables from '@/components/sections/plus/tables';

export default {
  name: 'plus-view',

  components: {
    TableElement,
    ...tables,
  },

  props: {
    showDeleted: Boolean,
  },

  watch: {
    $route() {
      this.changeParams({ only_deleted: this.$route.meta.showDeleted }, true);
    },

    params: {
      deep: true,
      handler: function() {
        this.fetch();
      },
    },
  },

  computed: {
    ...mapGetters({
      loading: 'plus/loading',
      params: 'plus/params',
      error: 'plus/error',
      list: 'plus/list',
    }),

    tableOptions() {
      return {
        list: this.list,

        order: this.params.order,
      };
    },

    tableType() {
      return this.$route.meta.tableType;
    },
  },

  methods: {
    ...mapActions({
      changeParams: 'plus/changeParams',
      fetch: 'plus/fetch',
    }),

    changePage(skip) {
      this.changeParams({
        skip,
      });
    },
  },

  beforeMount() {
    this.changeParams({ only_deleted: this.$route.meta.showDeleted }, true);
    this.fetch();
  },
};
</script>

<style lang='scss' scoped>
.plus-view {
  position: relative;
  min-height: 100%;
}
</style>
